import { render, staticRenderFns } from "./VehicleTypeMakeModal.vue?vue&type=template&id=09dc4df8&"
import script from "./VehicleTypeMakeModal.vue?vue&type=script&lang=js&"
export * from "./VehicleTypeMakeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports